/** Same-origin path nginx / CRA dev proxy forwards to Google Geocoding (key added server-side). */
export const DEFAULT_GOOGLE_GEOCODE_PROXY_PATH = '/geocode-proxy/google/json';

/** Whether asset address geocoding can use Google (proxy or build-time API key). */
export function isGoogleGeocodeAvailable(): boolean {
  if (process.env.REACT_APP_GOOGLE_GEOCODE_USE_PROXY === 'true') {
    return true;
  }
  return Boolean(process.env.REACT_APP_GOOGLE_MAPS_API_KEY?.trim());
}

/** Build a Google Geocoding JSON URL — same-origin proxy (no key) or direct API (key in query). */
export function buildGoogleGeocodeJsonUrl(searchParams: URLSearchParams): string | null {
  const useProxy = process.env.REACT_APP_GOOGLE_GEOCODE_USE_PROXY === 'true';
  if (useProxy) {
    const base =
      process.env.REACT_APP_GOOGLE_GEOCODE_PROXY_PATH?.trim() || DEFAULT_GOOGLE_GEOCODE_PROXY_PATH;
    return `${base.replace(/\/+$/, '')}?${searchParams.toString()}`;
  }
  const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY?.trim();
  if (!key) {
    return null;
  }
  searchParams.set('key', key);
  return `https://maps.googleapis.com/maps/api/geocode/json?${searchParams.toString()}`;
}
